import { render, staticRenderFns } from "./MessageThreadForm.vue?vue&type=template&id=bc946394"
import script from "./MessageThreadForm.vue?vue&type=script&lang=js"
export * from "./MessageThreadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports